import React from 'react';
import BlackCross from '../assets/images/BlackCross.svg';

export default () => {
  return <img src={BlackCross} alt="" />;
};
